import { DataSource, Layout, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutExciseTaxHistoryList extends Layout {
    searchpanelExciseTaxHistory: SearchPanel;
    sourceExcisetaxHistory: DataSource;
    tableExciseTaxHistory: Table;
    textboxAmountCSearch: Textbox;
    textboxAmountSearch: Textbox;
    textboxBillTypeSearch: Textbox;
    textboxCustomerIdSearch: Textbox;
    textboxDescrSearch: Textbox;
    textboxExcisetaxIdSearch: Textbox;
    textboxInvoiceIdSearch: Textbox;
    textboxOrderIdSearch: Textbox;
    textboxParentRowTypeSearch: Textbox;
    textboxPostDateSearch: Textbox;
    textboxRateSearch: Textbox;
    textboxStateIdProvince: Textbox;
    textboxTaxDateSearch: Textbox;
    textboxTaxableGrossSearch: Textbox;
    textboxUnitsSearch: Textbox;
}
